module.exports = __webpack_public_path__ + "static/img/test4.651b49d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/test/test4.jpg
// module id = 5Wdg
// module chunks = 2